import type { DocumentsListFilters } from '../../services/document-signature';

/** Position of `page` inside the list key — the only part paging is allowed to change. */
export const PAGE_KEY_INDEX = 8;

export const documentsArchiveQueryKeys = {
  all: ['documents-archive'] as const,
  list: (filters: DocumentsListFilters) =>
    [
      'documents-archive',
      'list',
      filters.category ?? 'ALL',
      filters.q ?? '',
      filters.archived ? 'archived' : 'active',
      filters.status ?? 'ALL',
      filters.from ?? '',
      filters.to ?? '',
      filters.page ?? 1,
      filters.pageSize ?? 0,
      // Appended AFTER pageSize so PAGE_KEY_INDEX stays valid. Without the expiry
      // range, moving the calendar to another month reused the previous month's cache.
      filters.expiryFrom ?? '',
      filters.expiryTo ?? '',
      filters.sort ?? 'createdAt',
      filters.assigneeUserId ?? '',
      filters.domain ?? '',
    ] as const,
};

/** True when two list query keys differ only by the requested page. */
export function isSamePageListKey(first: readonly unknown[], second: readonly unknown[]): boolean {
  return (
    first.length === second.length &&
    first.every((part, index) => index === PAGE_KEY_INDEX || part === second[index])
  );
}
